// 网络参数默认值

export const defaultNetParams = {
  channelMask: '11',
  extPanId: '50414e4944303032',
  channelPage: '0'
}

// 二代网关默认属性
export const defaultAttrGateway02 = {
  // 报警开关
  alarmSwitch: '1',

  // 音量大小
  alarmVoiceSize: 5,

  // 报警事件2s
  alarmTimeSize: 2,

  // 报警间隔
  alarmIntervalTime: 3,

  // 报警次数
  alarmSize: 1

  // //标签数量
  // tag_size: 2,

  // //MQTT 地址
  // mqtt_broker_address: '',

  // // MQTT端口
  // mqtt_connection_timeout: '',

  // // Mqtt 连接超时时间
  // mqtt_connection_timeout: 30,

  // // 	 Keep Alive Interval
  // mqtt_keep_alive_interval: 60,

  // // CleanSession
  // mqtt_clean_session: true,

  // // Mqtt 自动重连
  // mqtt_auto_reconnect: false,

  // //MaxInflight
  // mqtt_max_inflight: 10,
  // //数据保存时间
  // data_retention_time: 90,

  // //数据保存时间
  // equipment_limit_quantity: 60
}
